import {compose, createStore, applyMiddleware} from 'redux';
import rootReducer from '../reducer';
import thunk from 'redux-thunk';
import {persistStore, autoRehydrate} from 'redux-persist'

import queryString from 'query-string';
import { initProductTemplate } from '../templates/product';
import { init as initUI } from '../ui/init';

export default function configureStore(initialState) {
  const store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(thunk),
      autoRehydrate()
    )
  );

  const persistor = persistStore(store, {
    debounce: 1000,
    blacklist: ['familySearch', 'modal', 'palettes', 'ui'],
  }, () => {
    persistor.pause();

    const state = store.getState();
    const query = queryString.parse(window.location.search);
    initProductTemplate(store.dispatch, state, query);
    initUI(store.dispatch, state, query);
    persistor.resume();
  });
  return store;
}



// WEBPACK FOOTER //
// ./src/core/store/configureStore.prod.js